import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e0e9dc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__goal-management-student-detail p-12" }
const _hoisted_2 = { class: "__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center" }
const _hoisted_3 = { class: "__breadcrumbs__decorate" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Xem theo học sinh", -1))
const _hoisted_5 = { class: "__goal-management-student-detail__header pt-5" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-between items-center w-full\" data-v-5e0e9dc6><div class=\"flex items-center\" data-v-5e0e9dc6><img class=\"inline-block h-14 w-14 rounded-full border-2 border-orange-500\" src=\"https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=2&amp;w=256&amp;h=256&amp;q=80\" alt=\"\" data-v-5e0e9dc6><div class=\"ml-4\" data-v-5e0e9dc6><div class=\"font-bold text-neutral-700 text-4xl md-down:text-2xl\" data-v-5e0e9dc6> Hà Anh </div><div class=\"text-green-500 font-semibold text-xs uppercase\" data-v-5e0e9dc6> 28 tháng tuổi | Đã học 5 tháng </div></div></div><div class=\"flex space-x-4\" data-v-5e0e9dc6></div></div>", 1)
const _hoisted_7 = {
  key: 0,
  class: "mt-12"
}
const _hoisted_8 = { class: "border-b border-neutral-200" }
const _hoisted_9 = {
  class: "-mb-px flex space-x-8 tabs",
  "aria-label": "Tabs"
}
const _hoisted_10 = { class: "__goal-management-student-detail__overview px-12 pb-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: _ctx.routerName.RECORD_EMPLOYEE }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Danh sách học sinh ")
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DaIcon, {
            name: "das--chevron-down",
            class: "transform -rotate-90 h-3 w-3 mx-2"
          })
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (!_ctx.hideTab)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("nav", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: {
								name: _ctx.routerName.GOAL_MANAGEMENT_STUDENT_SUMMARY,
							},
                    class: "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Thống kê & Biểu đồ ")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {
								name: _ctx.routerName.GOAL_MANAGEMENT_STUDENT_SKILL_DETAILS,
							},
                    class: "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Chi tiết từng lĩnh vực ")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}